<div class="subpage-header-cta">
    <app-subpage-header #recommendationsHeaderRef [title]="title" size="small">
        <button
            class="preferences-button"
            (click)="openPreferencesDialog()"
            [matTooltip]="'Update your preference'"
            [matTooltipShowDelay]="1000"
            [matTooltipHideDelay]="2000">
            Update your preferences<mat-icon [svgIcon]="'chevron_right'" aria-hidden></mat-icon>
        </button>
    </app-subpage-header>
</div>

<ng-container *ngIf="cards$ | async as cards; else loading">
    <ng-container *ngIf="cards.length > 0; else noRecommendations">
        <ul>
            @for (card of cards | slice: 0 : length; track card.id || card.url || $index) {
                <li [id]="'card-' + card.id">
                    <ng-container *ngIf="!isCardRemoving(card.id); else loading">
                        <div class="remove-button-wrapper">
                            <button
                                *ngIf="card.type !== 'account'"
                                matTooltip="Remove recommendation"
                                matTooltipShowDelay="1000"
                                matTooltipHideDelay="2000"
                                (click)="onRemoveCard(card.id); $event.stopPropagation()"
                                aria-label="Remove card">
                                <mat-icon [svgIcon]="'close'" aria-hidden></mat-icon>
                            </button>
                        </div>
                        <app-card
                            cardClass="brand-neutral-card"
                            appearance="outlined"
                            [modal]="true"
                            (openModal)="onCardClick(card)">
                            <!-- Vimeo video thumbnail with play button -->
                            <div *ngIf="isVimeoVideo(card)" class="video-thumbnail-image">
                                <div class="image-wrapper" (click)="onCardClick(card)">
                                    <img [src]="getVimeoThumbnail(card)" [alt]="card.title + ' image'" />
                                    <app-play-button
                                        [showPlayButtonDuration]="true"
                                        [invert]="showInvertedPlayButton"
                                        [title]="card?.title"
                                        [duration]="getVideoDuration(card)">
                                    </app-play-button>
                                </div>
                            </div>

                            <!-- Wistia video thumbnail with play button -->
                            <div *ngIf="!isVimeoVideo(card) && isWistiaVideo(card)" class="video-thumbnail-image">
                                <div class="image-wrapper" (click)="onCardClick(card)">
                                    <img [src]="getWistiaThumbnail(card)" [alt]="card.title + ' image'" />
                                    <app-play-button
                                        [showPlayButtonDuration]="true"
                                        [invert]="showInvertedPlayButton"
                                        [title]="card?.title"
                                        [duration]="getVideoDuration(card)">
                                    </app-play-button>
                                </div>
                            </div>

                            <!-- YouTube video thumbnail with play button -->
                            <div
                                *ngIf="!isVimeoVideo(card) && !isWistiaVideo(card) && card?.ytthumbnailurl"
                                class="video-thumbnail-image">
                                <div class="image-wrapper" (click)="onCardClick(card)">
                                    <img [src]="card.ytthumbnailurl" [alt]="card.title + ' image'" />
                                    <app-play-button
                                        [showPlayButtonDuration]="true"
                                        [invert]="showInvertedPlayButton"
                                        [title]="card?.title"
                                        [duration]="getVideoDuration(card)">
                                    </app-play-button>
                                </div>
                            </div>

                            <!-- Regular image thumbnail (non-video) -->
                            <div
                                *ngIf="!isVimeoVideo(card) && !isWistiaVideo(card) && !card?.ytthumbnailurl"
                                class="image-wrapper">
                                <img [src]="cardImageUrl(card)" alt="Generic thumbnail" />
                            </div>

                            <div class="header">
                                <div class="card-tags">
                                    <span class="card-tag">{{ card?.info | uppercase }}</span>
                                    <span *ngIf="card?.customTag" class="card-tag-default-dark">{{
                                        card.customTag | uppercase
                                    }}</span>
                                </div>
                            </div>

                            <mat-card-content>
                                <h5 class="ellipsis-2">
                                    <a
                                        class="no-underline"
                                        (click)="onCardClick(card)"
                                        [attr.title]="card.title"
                                        aria-haspopup="dialog"
                                        [attr.data-analytics]="'home-recommendation-' + card.title">
                                        {{ card?.title }}
                                    </a>
                                </h5>
                                <p
                                    class="custom-message"
                                    *ngIf="card?.customMessage"
                                    [innerHTML]="card.customMessage"></p>
                                <p class="ellipsis-3" [title]="card?.description | stripHtml | decodeEntities">
                                    {{ card?.description | stripHtml | decodeEntities | truncate: 150 }}
                                </p>
                            </mat-card-content>

                            <mat-card-actions>
                                <span class="datetime-tag">
                                    <span>{{ card?.timestamp | date: 'MMMM d, yyyy' }}</span>
                                </span>
                                <a
                                    class="icon"
                                    [matTooltip]="'View ' + card?.title"
                                    [matTooltipShowDelay]="1000"
                                    [matTooltipHideDelay]="2000"
                                    aria-haspopup="dialog"
                                    [attr.data-analytics]="'home-recommendation-' + card?.title"
                                    (click)="onCardClick(card)">
                                    <mat-icon [svgIcon]="'chevron_right'" aria-hidden></mat-icon>
                                </a>
                            </mat-card-actions>
                        </app-card>
                    </ng-container>
                </li>
            }
        </ul>

        <div class="load-more-container">
            <app-load-more-button
                *ngIf="!isLoadMoreDisabled"
                [length]="length"
                [max]="max"
                [modifier]="modifier"
                [disabled]="isLoadMoreDisabled"
                (refreshLengthFn)="refreshLength($event)"></app-load-more-button>
        </div>
    </ng-container>
</ng-container>

<!-- No recommendations template -->
<ng-template #noRecommendations>
    <div class="no-recommendations">
        <p>No recommendations found.</p>
    </div>
</ng-template>

<ng-template #loading>
    <ul>
        @for (i of [1, 2, 3, 4]; track i) {
            <li>
                <app-loading-skeleton-card></app-loading-skeleton-card>
            </li>
        }
    </ul>
</ng-template>
